import { ValidatorFn, Validators } from "@angular/forms";
import { PasswordPattern } from "../_interfaces/password-pattern";
import { User } from "../_interfaces/user";
import { Language } from "../_enums/language";
import { environment } from "../../environments/environment";

export const GERMAN_SUPPORT_URL = 'https://help.tpro.io/customersupport-de/scribe';

export const SPECIAL_CHARS_REGEX = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

/** Filename of the API's default avatar when the user has not uploaded a photo. */
export const DEFAULT_AVATAR_FILENAME = 'img_placeholder_user.jpg';

/** Returns the avatar URL for display, or null when unset or still the API placeholder. */
export function resolveAvatarUrl(url: string | null | undefined): string | null {
    if (!url || url.includes(DEFAULT_AVATAR_FILENAME)) {
        return null;
    }
    return url;
}

export function resolveSupportUrl(user: User | null, currentLang: string | undefined): string {
    const isGermanEntity = user?.entity?.settings?.language === Language.German;
    const isGermanApp = currentLang?.endsWith('-de') ?? false;
    return isGermanEntity || isGermanApp ? GERMAN_SUPPORT_URL : environment.supportUrl;
}

export function buildPasswordPatternValidator(passwordPattern: PasswordPattern): ValidatorFn[] {
    const validators = [];
    if (passwordPattern.passwordLength) validators.push(Validators.minLength(passwordPattern.passwordLength));
    if (passwordPattern.passwordLowercase) validators.push(Validators.pattern(/[a-z]/));
    if (passwordPattern.passwordUppercase) validators.push(Validators.pattern(/[A-Z]/));
    if (passwordPattern.passwordNumbers) validators.push(Validators.pattern(/[0-9]/));
    if (passwordPattern.passwordSymbols) validators.push(Validators.pattern(SPECIAL_CHARS_REGEX));
    return validators;
}

export function getPasswordPattern(user: User): PasswordPattern {
    return {
        passwordLength: user.entity?.settings?.passwordLength,
        passwordLowercase: user.entity?.settings?.passwordLowercase,
        passwordUppercase: user.entity?.settings?.passwordUppercase,
        passwordNumbers: user.entity?.settings?.passwordNumbers,
        passwordSymbols: user.entity?.settings?.passwordSymbols,
    };
}